import { StateCreator } from 'zustand';

import { RewardFlowSlice } from './types';

const rewardFlowSlice: StateCreator<RewardFlowSlice> = (set) => ({
  preSelectedEmployees: [],
  preFilledGift: undefined,
  setPreSelectedEmployees: (employees) => set({ preSelectedEmployees: employees }),
  setPreFilledGift: (gift) => set({ preFilledGift: gift }),
  resetRewardFlowData: () => set({ preSelectedEmployees: [], preFilledGift: undefined }),
});

export default rewardFlowSlice;
